// Shrinks a picture in the browser before it goes up, so a big phone photo uploads in a second instead of a minute.
export const shrink = (file) => new Promise((done, fail) => {
  const img = new Image();
  img.onload = () => {
    const s = Math.min(1, 2048 / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * s);
    c.height = Math.round(img.height * s);
    const g = c.getContext("2d");
    g.fillStyle = "#FFFFFF";
    g.fillRect(0, 0, c.width, c.height);
    g.drawImage(img, 0, 0, c.width, c.height);
    c.toBlob((b) => (b ? done(b) : fail(new Error("Couldn't read that picture."))), "image/jpeg", 0.9);
    URL.revokeObjectURL(img.src);
  };
  img.onerror = () => fail(new Error("That file isn't a picture."));
  img.src = URL.createObjectURL(file);
});
